import React, { useEffect } from 'react';
import { youtubeAPI } from '../services/api';

export default function YouTubeOAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    const errorDescription = params.get('error_description');
    let clientId = null;
    // Try to get client_id from state param (if present)
    try {
      const state = params.get('state');
      if (state) {
        const stateObj = JSON.parse(state);
        clientId = stateObj.client_id;
      }
    } catch {}

    const finish = () => {
      if (window.opener) {
        window.opener.postMessage({ type: 'youtube_connected' }, '*');
        window.close();
      } else {
        setTimeout(() => {
          window.close();
          window.location.href = '/clients';
        }, 1500);
      }
    };

    const handleError = (errorMsg) => {
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'youtube_error',
            error: errorMsg,
          },
          '*'
        );
        window.close();
      } else {
        setTimeout(() => {
          window.close();
          window.location.href = '/';
        }, 2000);
      }
    };

    if (error) {
      handleError(errorDescription || error);
      return;
    }

    if (code && clientId) {
      youtubeAPI
        .exchangeYouTubeCode(code, clientId)
        .then(() => {
          finish();
        })
        .catch((err) => {
          console.error('YouTube OAuth error:', err);
          handleError(err.message);
        });
    } else {
      handleError('No authorization code or client ID received');
    }
  }, []);

  return <div>Connecting YouTube... Please wait.</div>;
}
